import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import useFirstRender from '../../hooks/FirstRender';
import { getOrderById } from '../../api/orderApi';
import { getCustomerById } from '../../api/customerApi';
import CustomerPicker from '../../components/customer/CustomerPicker';
import Input from '../../components/Input';
import { formatDate, onChange } from '../../utils/functions';
import Textarea from '../../components/Textarea';
import ProductLabel from '../../components/product/ProductLabel';
import { ORDER_RETURN_PATH, addOrderReturn, chargeOrderReturn, dechargeOrderReturn, deleteOrderReturn, getAllOrderReturns } from '../../api/orderReturnApi';
import { AiFillDelete } from 'react-icons/ai';
import { FaArrowRotateLeft } from 'react-icons/fa6';
import { getAllCuts } from '../../api/cutApi';
import OrderReturnSubmitModal from '../../components/returnment/OrderReturnSubmitModal';
import { useApiProgress } from '../../hooks/ApiProgress';
import { toast } from 'react-toastify';
import DeleteModal from '../../components/DeleteModal';

const OrderReturnPage = ({ title }) => {

    useEffect(() => {
        document.title = "İmperteks / " + title; // Sayfa başlığını güncelle
    }, [title]);

    const { id } = useParams()
    const isFirstRender = useFirstRender()
    const nav = useNavigate()

    const [customer, setCustomer] = useState()
    const [errors, setErrors] = useState({})
    const [order, setOrder] = useState({
        orderDate: "",
        vat: "",
        invoiceNumber: "",
        description: ""
    })
    const [cuts, setCuts] = useState([])
    const [returns, setReturns] = useState([])
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false)
    const [deleteId, setDeleteId] = useState()
    const [selectedCut, setSelectedCut] = useState({})
    const [returnAmount, setReturnAmount] = useState()
    const [returnPrice, setReturnPrice] = useState('')
    const [description, setDescription] = useState('')
    const [date, setDate] = useState('')
    const [isOpenSubmitModal, setIsOpenSubmitModal] = useState(false)
    const pendingApiCall = useApiProgress('post', `${ORDER_RETURN_PATH}/page`, false)

    useEffect(() => {
        getOrderById(id)
            .then(res => {
                setOrder(res.data)
                getCustomerById(res.data.customerId)
                    .then(res => {
                        setCustomer(res.data)
                    })
            })
        getAllCuts({ orderId: id })
            .then(res => {
                setCuts(res.data)
            })
        getAllOrderReturns({ orderId: id }).then(res => {
            setReturns(res.data)
        })
    }, [id])

    const onClickChargeReturn = (r) => {
        if (r.charged) {
            dechargeOrderReturn(r.id)
                .then(res => {
                    setReturns(prev => prev.map(p => p.id === res.data.id ? res.data : p))
                })
        } else {
            chargeOrderReturn(r.id)
                .then(res => {
                    setReturns(prev => prev.map(p => p.id === res.data.id ? res.data : p))
                })
        }
    }

    const onClickDeleteReturn = (id) => {
        setDeleteId(id)
        setIsOpenDeleteModal(true)
    }

    const onClickDelete = () => {
        deleteOrderReturn(deleteId)
            .then(res => {
                setReturns(prev => prev.filter(p => p.id !== deleteId))
                setDeleteId()
                setIsOpenDeleteModal(false)

            })
    }

    const onClickReturnCut = (cut) => {
        setSelectedCut(cut)
        setIsOpenSubmitModal(true)
        setReturnPrice(cut.unitPrice)
    }

    const onSubmitReturn = () => {
        const body = {
            unitPrice: returnPrice,
            quantity: returnAmount,
            cutId: selectedCut?.id,
            orderId: id,
            description,
            returnmentDate: date,
        }
        addOrderReturn(body)
            .then(res => {
                setReturns(prev => ([...prev, res.data]))
                setIsOpenSubmitModal(false)
                toast.success('Kaydedildi')
            }).catch(err => {
                setErrors(err.response.data.validationErrors)
                toast.error('Hata')
            })
    }

    return (
        <div>
            <div className='mb-5'>
                <label className='text-xl'>Sipariş İadesi</label>
            </div>
            <div className='border p-5 bg-white rounded-lg shadow-lg mb-5'>
                <label className='text-lg mb-3 block'>Detaylar</label>
                <div className='grid grid-cols-12 gap-x-3 mb-10'>
                    <CustomerPicker
                        label='Müşteri'
                        state={customer}
                        disabled
                    />
                    <div className='col-span-2'>
                        <Input
                            name='orderDate'
                            label='Sipariş Tarihi'
                            type='date'
                            value={order.orderDate}
                            error={errors?.orderDate}
                            onChange={e => onChange(e, setOrder, setErrors)}
                            disabled
                        />
                    </div>
                    <div className='col-span-2'>
                        <Input
                            name='vat'
                            label='Vergi Oranı (%)'
                            type='number'
                            placeholder='Vergi oranı...'
                            value={order.vat}
                            error={errors?.vat}
                            onChange={e => onChange(e, setOrder, setErrors)}
                            disabled
                        />
                    </div>
                    <div className='col-span-2'>
                        <Input
                            name='invoiceNumber'
                            label='Fatura Numarası'
                            type='text'
                            placeholder='Fatura numarası...'
                            value={order.invoiceNumber}
                            error={errors?.invoiceNumber}
                            onChange={e => onChange(e, setOrder, setErrors)}
                            disabled
                        />
                    </div>
                    <div className='col-span-2'>
                        <Textarea
                            name='description'
                            label='Açıklama'
                            type='text'
                            placeholder='Açıklama girin...'
                            value={order.description}
                            error={errors?.description}
                            onChange={e => onChange(e, setOrder, setErrors)}
                            disabled
                        />
                    </div>
                </div>
                <label className='text-lg mb-3 block'>Nakledilen Ürünler</label>
                {
                    cuts.map((cut, index) => (
                        <div key={index} className='flex justify-between py-1 border-b border-black mb-2'>
                            <div className='text-sm items-center'>
                                <div className='flex gap-x-2 items-center'>
                                    <label>{index + 1}. </label>
                                    <ProductLabel state={cut.roll.product} />
                                    {cut.orderDetail && <span className='bg-green-700 text-white px-2 py-1 text-xs rounded-full'>{cut.orderDetail.unitPrice} {order.currency}/m </span>}
                                    {cut.roll.boilerCode && <span className='pl-2'>Kazan no:  {cut.roll.boilerCode}</span>}
                                </div>
                            </div>
                            <div className='flex items-center gap-x-5'>
                                <label> {cut.quantity} m</label>

                                <span className='cursor-pointer hover:scale-125 hover:text-blue-600 duration-150' onClick={() => onClickReturnCut(cut)}>
                                    <FaArrowRotateLeft />
                                </span>
                            </div>
                        </div>
                    ))
                }

            </div>
            <div className='border p-5 bg-white rounded-lg shadow-lg'>
                <label className='text-lg mb-3 block'>İadeler</label>
                <table className='w-full text-left text-zinc-900 mb-3'>
                    <thead className='text-xs uppercase tracking-wide bg-white'>
                        <tr>
                            <th className='p-2 w-1/24'>#</th>
                            <th className='p-2 w-3/12'>Ürün</th>
                            <th className='p-2 w-3/12'>Kazan No</th>
                            <th className='p-2 w-1/12'>İade Tarihi</th>
                            <th className='p-2 w-2/12 normal-case'>{`İADE BİRİM FİYAT ${customer ? `(${customer.currency}/m)` : ""}`}</th>
                            <th className='p-2 w-1/12'>İade Miktarı</th>
                            <th className='p-2 w-1/12'>Hesapta</th>
                            <th className='p-2 w-1/24'>Aksiyon</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            returns.map((r, index) => (
                                <tr key={index} className='border-b items-center text-sm'>
                                    <td className='p-2'>
                                        <span className='text-xs'></span> {index + 1}
                                    </td>
                                    <td className='p-2'>{<ProductLabel state={r.cut?.roll?.product} />} </td>
                                    <td className='p-2'>{r.cut?.roll?.boilerCode}</td>
                                    <td className='p-2'>{formatDate(r.returnmentDate)}</td>
                                    <td className='p-2'>{r.unitPrice}</td>
                                    <td className='p-2'>{r.quantity} m</td>
                                    <td className='p-2 text-center flex'>
                                        <input
                                            type='checkbox'
                                            checked={r.charged}
                                            defaultChecked={r.charged}
                                            onChange={() => onClickChargeReturn(r)}
                                        />
                                    </td>
                                    <td>
                                        {
                                            !r.charged &&
                                            <span
                                                className='cursor-pointer hover:scale-125 hover:text-red-600 duration-150'
                                                onClick={() => onClickDeleteReturn(r.id)}
                                            >
                                                <AiFillDelete />
                                            </span>
                                        }

                                    </td>
                                </tr>
                            ))
                        }
                    </tbody>
                </table>
            </div>

            <OrderReturnSubmitModal
                isOpen={isOpenSubmitModal}
                closeModal={() => setIsOpenSubmitModal(false)}
                setReturnAmount={setReturnAmount}
                returnAmount={returnAmount}
                setReturnPrice={setReturnPrice}
                returnPrice={returnPrice}
                setDescription={setDescription}
                description={description}
                setDate={setDate}
                date={date}
                errors={errors}
                setErrors={setErrors}
                pendingApiCall={pendingApiCall}
                onClick={onSubmitReturn}
                cut={selectedCut}
            />
            <DeleteModal
                isOpen={isOpenDeleteModal}
                closeModal={() => setIsOpenDeleteModal(false)}
                onClick={onClickDelete}
            />
        </div>
    )
}

export default OrderReturnPage